const Menu = [
    {
       title: 'Dashboard',
       icon: 'fas fa-chart-pie',
       route: '/dashboard'
    },
    {
       title: 'Afiliados',
       icon: 'fas fa-users',
       route: '/affiliates'
    },
    {
      title: 'Produtos e Links',
      icon: 'fas fa-link',
      route: '/links'
    },
    {
      title: 'Produção', 
      icon: 'fas fa-file-signature',
      route: '/production'
    },
    {
      title: 'Campanhas', 
      icon: 'fas fa-share-alt',
      route: '/campaigns'
    },
    {
      title: 'Produção por Campanha',
      icon: 'fas fa-money-check-alt',
      route: '/campaignLeads'
   	},
    {
      title: 'Carteira', 
      icon: 'fas fa-piggy-bank',
      route: '/wallet'
   },
   {
     title: 'Meu Cadastro', 
     icon: 'fas fa-user',
     route: '/profile'
   }
 ];

 /*
 // reorder menu
 Menu.forEach((item) => {
    if (item.items) {
       item.items.sort((x, y) => {
          let textA = x.title.toUpperCase();
          let textB = y.title.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
       });
    }
 });
 */
 
 export default Menu;
 


// WEBPACK FOOTER //
// ./src/api/menu.js